import React from 'react';
import PropTypes from 'prop-types';
import InputMask from 'react-input-mask';

import { ID } from 'utilz';

import './styles.scss';

const Input = ({
  changeHandl, type, masked, value, reference, placeholder, onClickHandl, isFloating,
  isError, keyAction
}) => {
  const generatedId = ID();

  return (
    masked ? <InputMask
      mask={masked}
      maskChar=" "
      onChange={changeHandl}
      className="input"
      value={value}
      type={type}
      placeholder={placeholder}
    /> :
    <div className="input-wrapper">
      <input
        type={type}
        id={generatedId}
        onChange={changeHandl}
        className={`input ${value.length !== 0 ? '-active' : ''} ${isError ? '-isError' : ''}`}
        value={value}
        ref={reference || null}
        onClick={onClickHandl}
        placeholder={!isFloating ? placeholder : ''}
        onKeyDown={keyAction}
      />
      { placeholder !== '' && isFloating ? (
        <label htmlFor={generatedId} className={`label ${value.length !== 0 ? '-active' : ''}`}>
          { placeholder }
        </label>
      ) : null }
    </div>
  );
};

Input.defaultProps = {
  type: 'text',
  masked: null,
  value: '',
  reference: false,
  placeholder: '',
  onClickHandl: () => {},
  keyAction: () => {},
  changeHandl: () => {},
  isFloating: true,
  isError: false
};

Input.propTypes = {
  type: PropTypes.string,
  value: PropTypes.string,
  masked: PropTypes.string,
  changeHandl: PropTypes.func,
  onClickHandl: PropTypes.func,
  keyAction: PropTypes.func,
  placeholder: PropTypes.string,
  isFloating: PropTypes.bool,
  isError: PropTypes.bool,
  reference: PropTypes.oneOfType([PropTypes.func, PropTypes.bool])
};

export default Input;



// WEBPACK FOOTER //
// ./src/components/Input/index.js